export const MARKETING_CHANNEL_OTHER_OPTION_TITLE = '其他';
export const GENDER_OPTION_LIST = [
    { value: 'male', title: '男' },
    { value: 'female', title: '女' },
    { value: 'nonBinary', title: '其他' },
];
export const HOME_CARE_TITLE = '居家照顧';
export const NO_TUBE_OPTION = {
    title: '無',
};
export const REQUIRED_GENDER_OPTION_LIST = [
    { value: 'male', title: '男' },
    { value: 'female', title: '女' },
    { value: 'no', title: '不指定' },
];
export const LANG_OPTION_LIST = [
    { value: 'ch', title: '中文' },
    { value: 'tw', title: '台語' },
    { value: 'hak', title: '客語' },
    { value: 'frgn', title: '外語' },
    { value: 'no', title: '其他＊請填寫於備註' },
];
